import _ from 'lodash';
import InsightsApi from '../../api/InsightsApi';
import SumsumApi from '../../api/SumsumApi';

const INSIGHT_NAMES = {
  // transaction insights (on specific transactions)
  HighExpense: 'highExpense',
  RelativeHighExpense: 'relativeHighExpense',
  HighIncomeExclusion: 'highIncomeExclusion',
  RelativeIncomeExclusion: 'relativeIncomeExclusion',
  LoanExclusion: 'loanExclusion',
  MightBeFixed: 'mightBeFixed',
  // balance insights (on balance event)
  EconomyBalance: 'economyBalance',
  FixedBalance: 'fixedBalance',
  RecurringBalance: 'recurringBalance',
  ZeroBalance: 'zeroBalance',
  // activation insight (first 2 days after activation)
  Activation: 'activation',
  // tracking insight (first 2 days after activation)
  TrackingCategories: 'trackingCategories',
  // savings
  OpportunisticSaving: 'OpportunisticSaving',
  MonthlySaving: 'MonthlySaving',
  HarelMonthlySaving: 'HarelMonthlySaving',
  MeitavOpportunisticSaving: 'MeitavOpportunisticSaving',
  MeitavMonthlySaving: 'MeitavMonthlySaving',
  // sumsum
  DemographicInfo: 'demographicInfo',
  // fees insight (first 2 weeks after activation)
  FeesInsight: 'feesInsight',
  NegativeBalanceInsight: 'negativeBalanceInsight',
  RollingCreditInsight: 'rollingCredit',
  ChallengeInsight: 'challengeInsight',
};

const HIDDEN_INSIGHTS = [];
const KNOWN_INSIGHTS = _.difference(_.values(INSIGHT_NAMES), HIDDEN_INSIGHTS);

const EXCLUSION_INSIGHTS = [
  INSIGHT_NAMES.LoanExclusion,
  INSIGHT_NAMES.HighIncomeExclusion,
  INSIGHT_NAMES.HighExpense,
  INSIGHT_NAMES.RelativeIncomeExclusion,
  INSIGHT_NAMES.RelativeHighExpense,
];

const state = {
  insights: [],
};

const getters = {
  INSIGHT_NAMES: () => INSIGHT_NAMES,
  sortedInsights: state => _.sortBy(state.insights, insight => {
    if (insight.insightName === INSIGHT_NAMES.TrackingCategories || insight.insightName === INSIGHT_NAMES.Activation) {
      return 30;
    }
    if (insight.insightName === INSIGHT_NAMES.DemographicInfo) {
      return 20;
    }
    if (_.includes(EXCLUSION_INSIGHTS, insight.insightName)) {
      return 10;
    }
    if (insight.insightName === INSIGHT_NAMES.EconomyBalance) {
      return 5;
    }
    return 1;
  }),
};

const actions = {
  async initInsights({ commit }) {
    const [insights, sumsumInsights] = await Promise.all([
      InsightsApi.fetchInsights(),
      SumsumApi.getInsights(),
    ]);
    const knownInsights = [...insights, ...sumsumInsights].filter(insight => KNOWN_INSIGHTS.includes(insight.insightName));
    commit('setInsights', knownInsights);
  },
  async clearInsight({ commit }, insight) {
    commit('clearInsight', insight.insightId);
  },
  async markAsRead({ commit }, insight) {
    commit('clearInsight', insight.insightId);
    await InsightsApi.markAsRead(insight.insightId, insight.insightName, insight);
  },
  async sendInsightFeedback({ commit }, { insight, feedback }) {
    await InsightsApi.sendInsightFeedback(insight.insightId, insight.insightName, insight, feedback);
  },
};

// mutations
const mutations = {
  setInsights(state, insights) {
    state.insights = insights;
  },
  clearInsight(state, insightId) {
    const indexToSlice = _.findIndex(state.insights, insight => insight.insightId === insightId);
    state.insights.splice(indexToSlice, 1);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
